/**
 * Đọc, ghi video ở Firestore `videos` (trang /admin/video). Mã YouTube là khoá.
 * Trang công khai không gọi file này: chúng dùng bản kéo về lúc build
 * (src/data/videos.js), nên không tốn lượt đọc Firestore nào.
 */
import { layDb } from './firebase.js';
import { chuanHoaVideo, kiemTraVideo } from '@shared/video.js';
import { coTrang } from './videoTrang.js';

export async function docTatCaVideo() {
  const db = await layDb();
  if (!db) throw new Error('Website chưa cấu hình Firestore.');
  const { collection, getDocs } = await import('firebase/firestore/lite');
  const snap = await getDocs(collection(db, 'videos'));
  return snap.docs.map((d) => chuanHoaVideo({ ...d.data(), id: d.id }));
}

export async function luuVideo(raw, status) {
  const v = chuanHoaVideo({ ...raw, status });
  const loi = kiemTraVideo(v, coTrang);
  if (loi.length) throw new Error(loi.join(' '));
  const db = await layDb();
  const { doc, setDoc, serverTimestamp } = await import('firebase/firestore/lite');
  const ghi = { ...v, thoiLuong: v.thoiLuong ?? 0 };
  await setDoc(doc(db, 'videos', v.id), { ...ghi, updatedAt: serverTimestamp() });
  return v;
}

export async function xoaVideo(id) {
  const db = await layDb();
  const { doc, deleteDoc } = await import('firebase/firestore/lite');
  await deleteDoc(doc(db, 'videos', id));
}

/** Tiêu đề video từ YouTube (oEmbed công khai). Lỗi thì trả về chuỗi rỗng. */
export async function layTieuDeYoutube(id) {
  try {
    const r = await fetch(`https://www.youtube.com/oembed?format=json&url=${encodeURIComponent(`https://www.youtube.com/shorts/${id}`)}`);
    if (!r.ok) return '';
    return (await r.json()).title || '';
  } catch { return ''; }
}
